import { render, staticRenderFns } from "./toBeWholesaler.vue?vue&type=template&id=4d9cf6d6&scoped=true&"
import script from "./toBeWholesaler.vue?vue&type=script&lang=js&"
export * from "./toBeWholesaler.vue?vue&type=script&lang=js&"
import style0 from "./toBeWholesaler.vue?vue&type=style&index=0&id=4d9cf6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9cf6d6",
  null
  
)

export default component.exports